webpackJsonp([198830598414290],{

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

	// the whatwg-fetch polyfill installs the fetch() function
	// on the global object (window or self)
	//
	// Return that as the export for use in Webpack, Browserify etc.
	__webpack_require__(365);
	module.exports = self.fetch.bind(self);


/***/ }),

/***/ 365:
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProblemList = function (_React$Component) {
	  _inherits(ProblemList, _React$Component);
	
	  function ProblemList() {
	    _classCallCheck(this, ProblemList);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ProblemList.prototype.renderProblems = function renderProblems() {
	    return this.props.problems.map(function (item) {
	      return _react2.default.createElement(
	        'li',
	        { className: 'item', key: item.id },
	        _react2.default.createElement(Problem, {
	          title: item.title
	        })
	      );
	    });
	  };
	
	  ProblemList.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'box shadow superpadded' },
	      _react2.default.createElement(
	        'div',
	        { className: 'box-title' },
	        _react2.default.createElement(_header2.default, {
	          key: 'header',
	          className: 'text-center',
	          text: 'Problem(s) we are currently working on'
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'box-body' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'list margin-t-60 nav flex-column ' + (this.props.className ? this.props.className : '') },
	          this.renderProblems()
	        )
	      )
	    );
	  };
	
	  return ProblemList;
	}(_react2.default.Component);
	
	exports.default = ProblemList;
	
	
	var Problem = function Problem(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'row justify-content-left align-items-center' },
	    _react2.default.createElement('div', { className: 'activity-circle pulse red glow' }),
	    _react2.default.createElement(
	      'p',
	      { className: 'text para-1 grey light col-11 margin-0' },
	      props.title
	    )
	  );
	};
	module.exports = exports['default'];

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header4 = function Header4(props) {
	  return _react2.default.createElement(
	    'h4',
	    { className: 'text header-4 stronger ' + (props.className ? props.className : '') },
	    props.text
	  );
	};
	
	exports.default = Header4;
	module.exports = exports['default'];

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _navbar = __webpack_require__(9);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _layout = __webpack_require__(10);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _button = __webpack_require__(18);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _header = __webpack_require__(4);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _header3 = __webpack_require__(32);
	
	var _header4 = _interopRequireDefault(_header3);
	
	var _header5 = __webpack_require__(97);
	
	var _header6 = _interopRequireDefault(_header5);
	
	var _para = __webpack_require__(12);
	
	var _para2 = _interopRequireDefault(_para);
	
	var _para3 = __webpack_require__(13);
	
	var _para4 = _interopRequireDefault(_para3);
	
	var _problemList = __webpack_require__(152);
	
	var _problemList2 = _interopRequireDefault(_problemList);
	
	var _Dreamer = __webpack_require__(341);
	
	var _Dreamer2 = _interopRequireDefault(_Dreamer);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(294);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Home = function (_React$Component) {
	  _inherits(Home, _React$Component);
	
	  function Home() {
	    _classCallCheck(this, Home);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  // event handler
	  Home.prototype.handlePostProblemClick = function handlePostProblemClick(e) {
	    e.preventDefault();
	
	    window.open('https://surebro.typeform.com/to/VdZ7oP', '_blank');
	  };
	  // render methods
	
	
	  Home.prototype.render = function render() {
	    return _react2.default.createElement(
	      _layout2.default,
	      { key: 'main-layout' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Surebro: We\'ll solve your problems'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'We solve problems for free. Post your problem and we will build you an application, web or mobile that will hopefully solve your problem. For free. Really free' }),
	        _react2.default.createElement('meta', { property: 'og:url', content: 'https://surebro.com/problems' }),
	        _react2.default.createElement('meta', { property: 'og:title', content: 'Surebro: We\'ll solve your problems' }),
	        _react2.default.createElement('meta', { property: 'og:description', content: 'We solve problems for free. Post your problem and we will build you an application, web or mobile that will hopefully solve your problem. For free. Really free' }),
	        _react2.default.createElement('meta', { property: 'og:image', content: 'https://res.cloudinary.com/surebro/image/upload/v1530280290/Social-share-cover_t18uos.png' })
	      ),
	      _react2.default.createElement(_navbar2.default, { key: 'navbar', active: 2, className: 'yellow' }),
	      _react2.default.createElement(
	        'section',
	        { className: 'container', style: { marginTop: '160px' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'row justify-content-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-8 col-md-10 col-xs-12' },
	            _react2.default.createElement(_header2.default, {
	              key: 'header',
	              className: 'text-center stronger',
	              text: 'We\'ll build you an application for Free',
	              decoration: { text: 'for Free', type: 'underline', color: 'yellow' }
	            }),
	            _react2.default.createElement(_para2.default, {
	              key: 'sub-title',
	              className: 'text-center grey light',
	              text: 'Tell us your problems and we will build a website, application, anything that solves your problem for free'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row justify-content-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-sm-6' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row justify-content-center' },
	              _react2.default.createElement(_button2.default, {
	                key: 'primary-button',
	                onClick: this.handlePostProblemClick.bind(this),
	                text: 'Post your Problem',
	                className: 'yellow center-block margin-t-20'
	              })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('div', { className: 'container-fluid margin-t-60 project-strip', style: {
	          backgroundImage: 'url(https://res.cloudinary.com/surebro/image/upload/q_auto/v3-static/ApplicationStrip_2x.35b42f85)'
	        } }),
	      _react2.default.createElement(
	        'section',
	        { className: 'container margin-t-100' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row justify-content-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-8 col-md-10 col-xs-12' },
	            _react2.default.createElement(_header2.default, {
	              key: 'header',
	              className: 'text-center stronger',
	              text: 'We are Engineers and Designers'
	            }),
	            _react2.default.createElement(_para2.default, {
	              key: 'sub-title',
	              className: 'text-center grey light',
	              text: 'All we want to do is solve real problem faced by real people. Everyone encounters this one problem that is painfully obvious'
	            }),
	            _react2.default.createElement(_para2.default, {
	              key: 'sub-title-2',
	              className: 'text-center grey strong',
	              text: '\u201CWhy is there no app that helps with this?\u201D'
	            }),
	            _react2.default.createElement(_para2.default, {
	              key: 'sub-title-3',
	              className: 'text-center grey light',
	              text: 'Well, if you tell us, we\u2019ll build it and it\u2019ll be free'
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'container margin-t-100' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row justify-content-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-lg-12' },
	            _react2.default.createElement(
	              'div',
	              { className: 'row align-items-center' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md' },
	                _react2.default.createElement(_header4.default, {
	                  key: 'step-one-title',
	                  className: 'text-left margin-t-10',
	                  text: 'Your dreams will come true'
	                }),
	                _react2.default.createElement(_para4.default, {
	                  key: 'step-one-subtitle',
	                  className: 'text-left grey margin-t-10 spread',
	                  text: 'All you need to do is share your dreams. Share your problems, propose a solution, point to a solution\\ that needs a minor tweak. Anything. We will build it for you. And it will not cost you a penny. You will be\\ the reason it exists. Imagine the bragging rights.'
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-md mobile-flex-first' },
	                _react2.default.createElement('img', { src: _Dreamer2.default, className: 'img-fluid rounded mx-auto d-block img-max-h-400', alt: 'Dream on Dreamer' })
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'container margin-t-100', onClick: this.handlePostProblemClick.bind(this) },
	        _react2.default.createElement(
	          'button',
	          { className: 'yellow super button padding-50 ' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(_para2.default, {
	              key: 'richard-intro',
	              className: 'text-left white',
	              text: 'In the words of the mighty Richard Branson, '
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(_header2.default, {
	              key: 'richard-title',
	              className: 'stronger text-left underline white',
	              text: 'Screw it, Let\u2019s do it'
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return Home;
	}(_react2.default.Component);
	
	exports.default = Home;
	module.exports = exports['default'];

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Dreamer.c2d61bcf.svg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-problems-js-cae25523ea0863f7d90a.js